"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNestableDef = exports.fromWidgetField = exports.WidgetDef = void 0;
const tslib_1 = require("tslib");
const t = tslib_1.__importStar(require("io-ts"));
const GroupDef_1 = require("./GroupDef");
const nestable_1 = require("./nestable");
const slices_1 = require("./slices");
const UIDDef_1 = require("./UIDDef");
exports.WidgetDef = t.union([slices_1.SlicesDef, GroupDef_1.GroupDef, UIDDef_1.UIDDef, nestable_1.NestableDef]);
function fromWidgetField(def, sharedSlices) {
    switch (def.type) {
        case "Choice":
        case "Slices":
            return (0, slices_1.fromSlices)(def, sharedSlices);
        case "Group":
            return (0, GroupDef_1.fromGroupField)(def);
        case "UID":
            return (0, UIDDef_1.fromUIDField)(def);
        default:
            return (0, nestable_1.fromNestableField)(def);
    }
}
exports.fromWidgetField = fromWidgetField;
function isNestableDef(def) {
    return (def.type === "Boolean" ||
        def.type === "Color" ||
        def.type === "Date" ||
        def.type === "Embed" ||
        def.type === "GeoPoint" ||
        def.type === "Image" ||
        def.type === "IntegrationFields" ||
        def.type === "Link" ||
        def.type === "Number" ||
        def.type === "Range" ||
        def.type === "Select" ||
        def.type === "Separator" ||
        def.type === "StructuredText" ||
        def.type === "Text" ||
        def.type === "Timestamp");
}
exports.isNestableDef = isNestableDef;
